import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted } from 'vue'
    import { useRoute } from '@common/composables'
    import { useShareNotificationPage } from '@DataSharing/Shares/pages-core'
    import '@common/Components/ValidationError.vue'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ShareNotificationPage',
  setup(__props) {

    document.title = 'Share data'

    const route = useRoute()
    const shareId = route.params.shareId

    const selectedEmails = ref([])
    const message = ref('')

    const organizationName = computed(() => modelShareNotificationQueryV1.value?.OrganizationUnitName)
    const workspaceName = computed(() => modelShareNotificationQueryV1.value?.WorkspaceName)
    const projectName = computed(() => modelShareNotificationQueryV1.value?.ProjectName)
    const resourceName = computed(() => modelShareNotificationQueryV1.value?.ResourceName)
    const resourceUrl = computed(() => modelShareNotificationQueryV1.value?.ResourceUrl)
    const resourceProviderName = computed(() => modelShareNotificationQueryV1.value?.ResourceProviderName)
    const resourceId = computed(() => modelShareNotificationQueryV1.value?.ResourceId)
    const emails = computed(() => modelShareNotificationQueryV1.value?.Emails || [])

    const { useShareNotificationQuery, useSendNotificationCommand } = useShareNotificationPage()

    const { modelShareNotificationQueryV1, runShareNotificationQueryV1, succeed } = useShareNotificationQuery(shareId)

    const { invokeSendNotificationCommandV1, succeedSendNotificationCommandV1, invokingSendNotificationCommandV1 } = useSendNotificationCommand(shareId, message, selectedEmails)

    onMounted(() => runShareNotificationQueryV1())

    watch(succeed, () => {
        if (emails.value.length == 0) {
            navigateToResourceSharePage()
        }
    })

    function navigateToResourceSharePage() {
        location.href = `/#/sharing/resource/${resourceProviderName.value}/${resourceId.value}`
    }

return { __sfc: true,route, shareId, selectedEmails, message, organizationName, workspaceName, projectName, resourceName, resourceUrl, resourceProviderName, resourceId, emails, useShareNotificationQuery, useSendNotificationCommand, modelShareNotificationQueryV1, runShareNotificationQueryV1, succeed, invokeSendNotificationCommandV1, succeedSendNotificationCommandV1, invokingSendNotificationCommandV1, navigateToResourceSharePage }
}

})